import { enGeste } from './geste79';
// LOT 45 §4 ter · §7 · la couleur d'un texte se choisit selon son fond : contraste ≥ 4,5:1 partout, aucune carte blanche la nuit
const rgb = (c) => { const m = c && c.match(/rgba?\(([^)]+)\)/); if (!m) return null; const p = m[1].split(',').map(parseFloat); return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 }; };
const lum = ({ r, g, b }) => { const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }; return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b); };
const ratio = (a, b) => { const x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); };
const nuit = () => !document.documentElement.classList.contains('jour');
const horsApp = () => !document.getElementById('root') || /^\/(site|connexion)(\/|$)/.test(window.location.pathname);

const fondDe = (el) => {
  const pile = [];
  for (let e = el; e && e.nodeType === 1; e = e.parentElement) {
    const cs = getComputedStyle(e);
    if (cs.backgroundImage && cs.backgroundImage !== 'none') return null;
    const c = rgb(cs.backgroundColor);
    if (c && c.a > 0) { pile.push(c); if (c.a >= 0.99) break; }
  }
  let res = nuit() ? { r: 28, g: 23, b: 20 } : { r: 255, g: 255, b: 255 };
  for (let i = pile.length - 1; i >= 0; i--) { const c = pile[i]; res = { r: c.r * c.a + res.r * (1 - c.a), g: c.g * c.a + res.g * (1 - c.a), b: c.b * c.a + res.b * (1 - c.a) }; }
  return res;
};

const BLANC = { r: 255, g: 255, b: 255 }; const ENCRE = { r: 28, g: 23, b: 20 };
const corriger = () => {
  const soir = nuit();
  const carteNuit = (getComputedStyle(document.body).getPropertyValue('--carte') || '').trim() || '#2A231F';
  document.querySelectorAll('[data-ca]').forEach((e) => { e.style.removeProperty('color'); e.style.removeProperty('background-color'); delete e.dataset.ca; });
  if (horsApp()) return;  // site public : ses propres couleurs (fond clair), jamais le mode nuit de l'app
  const root = document.body;
  root.querySelectorAll('*').forEach((el) => {
    if (el.closest('svg, img, video, canvas, [data-garde-couleur], [data-garde-couleur] .acm-rep')) return;
    const r = el.getBoundingClientRect(); if (!r.width || !r.height) return;
    const cs = getComputedStyle(el);
    if (soir && r.width > 120 && r.height > 60) { const b = rgb(cs.backgroundColor); if (b && b.a > 0.95 && b.r > 235 && b.g > 235 && b.b > 225 && !el.closest('.jour-force, .ap31-ap, [data-testid^="reglages-apparence"]')) { el.style.setProperty('background-color', carteNuit, 'important'); el.dataset.ca = 'n'; } }
    if (![...el.childNodes].some((n) => n.nodeType === 3 && n.textContent.trim())) return;
    if (cs.visibility === 'hidden' || +cs.opacity < 0.5) return;
    const c = rgb(cs.color); const f = fondDe(el); if (!c || !f) return;
    const vu = { r: c.r * c.a + f.r * (1 - c.a), g: c.g * c.a + f.g * (1 - c.a), b: c.b * c.a + f.b * (1 - c.a) };
    const gros = parseFloat(cs.fontSize) >= 24 || (parseFloat(cs.fontSize) >= 18.66 && +cs.fontWeight >= 700);
    const rv = ratio(vu, f);
    if (rv >= (gros ? 3 : 4.5) || rv < 1.05) return;
    const choix = ratio(BLANC, f) >= ratio(ENCRE, f) ? '#FFFFFF' : '#1C1714';
    el.style.setProperty('color', choix, 'important'); el.dataset.ca = soir ? 'n' : 'j';
  });
};

let t = 0;
// LOT 79 · jamais pendant qu'on tape ou qu'on touche l'écran : la relecture des couleurs attend 1 s de calme (sinon une lettre attendait 0,15 s)
const plan = () => { if (t) return; t = setTimeout(() => (window.requestIdleCallback || setTimeout)(() => { t = 0; if (enGeste()) { plan(); return; } try { corriger(); } catch { /* rien */ } }), 500); };
export const demarrerContrasteAuto = () => {
  new MutationObserver(plan).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('mode360', plan); window.addEventListener('resize', plan);
  plan();
};
